import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Configuration } from '@/types';

export interface ConfigState {
  configurations: Configuration[];
}

const initialState: ConfigState = {
  configurations: [],
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfigurations(state, action: PayloadAction<Configuration[]>) {
      state.configurations = action.payload ?? [];
    },
  },
});

export const { setConfigurations } = configSlice.actions;
export default configSlice.reducer;
